import styled from 'styled-components';

const SectionWrapper = styled.section`
  padding: 25px 0;
  background: ${props => props.bgc ? props.bgc : ''};
`;

export default SectionWrapper